import React from "react";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
} from "@mui/lab";
import { Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const statusColors = {
  YENI_BASVURU: "primary", // primary
  IKINCI_BASVURU: "info", // info
  GORUSULDU_OLUMLU: "success", // success
  GORUSULDU_OLUMSUZ: "error", // error
  YEDEK_ADAY: "warning", // warning
};

/**
 *
 * @param {{list:import("../../services/CandidateHistoryService").DKN_DMY_ADAY_TARIHCE[]}} props
 */
export default function CandidateHistory(props) {
  const { t } = useTranslation();
  const { list } = props;
  const interviewStatusData = React.useMemo(
    () => t("jobApplication.interview_status_data", { returnObjects: true }),
    [t]
  );
  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString("tr-TR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };
  return (
    <Timeline position="alternate">
      {list.map((item, index) => (
        <TimelineItem key={item.dkN_DMY_ADAY_TARIHCE_ID}>
          <TimelineSeparator>
            <TimelineDot color={statusColors[item.adaY_GORUSME_DURUMU]} />
            {index < list.length - 1 && <TimelineConnector />}
          </TimelineSeparator>
          <TimelineContent>
            <Paper elevation={3} sx={{ p: 2, mb: 2 }}>
              <Typography variant="h6" component="h6">
                {
                  interviewStatusData.find(
                    (d) => d.value === item.adaY_GORUSME_DURUMU
                  )?.text
                }
              </Typography>
              {item.i_K_ACIKLAMA && (
                <Typography variant="body2" color="textSecondary">
                  {item.i_K_ACIKLAMA}
                </Typography>
              )}
              <Typography variant="caption" display="block">
                {formatDate(item.crE_DATE)}
              </Typography>
              <Typography variant="caption" color="textSecondary">
                İşlemi Yapan: {item.aD_SOYAD}
              </Typography>
            </Paper>
          </TimelineContent>
        </TimelineItem>
      ))}
    </Timeline>
  );
}
